function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 .5h2v10H8V.5zm5.41 3.59l1.42-1.42A8.932 8.932 0 0118 9.5a9 9 0 01-18 0c0-2.74 1.23-5.18 3.17-6.83l1.41 1.41A6.995 6.995 0 009 16.5c3.87 0 7-3.13 7-7a6.92 6.92 0 00-2.59-5.41z"
});

function SvgDisconnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDisconnect;